// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oxygen:700,400,300);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  background-color: #e8f0fa;
  font-family: 'Oxygen', sans-serif;
}

.demo-schedule {
  /* height: 100vh; */
  margin: 24px;
  margin-top: 44px;

  /* .day-columns {
    height: 100%;
  } */

  /* .weekly-schedule {
    gap: 40px;
  }

  .date-navigator {
    font-size: 10px;
    color: red;
  } */
}
`, "",{"version":3,"sources":["webpack://./demo/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;;EAEhB;;KAEG;;EAEH;;;;;;;KAOG;AACL","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Oxygen:700,400,300);\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  background-color: #e8f0fa;\n  font-family: 'Oxygen', sans-serif;\n}\n\n.demo-schedule {\n  /* height: 100vh; */\n  margin: 24px;\n  margin-top: 44px;\n\n  /* .day-columns {\n    height: 100%;\n  } */\n\n  /* .weekly-schedule {\n    gap: 40px;\n  }\n\n  .date-navigator {\n    font-size: 10px;\n    color: red;\n  } */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
